// One lightweight tooltip shared by every card, outside clipped carousel tracks.
const selector = '[data-laasa-colour]';
let tooltip;
let active;
function hide() {
  if (tooltip) tooltip.hidden = true;
  active = null;
}
function show(label) {
  if (!window.matchMedia('(hover: hover)').matches) return;
  if (!tooltip) {
    tooltip = document.createElement('div');
    tooltip.className = 'laasa-colour-tooltip';
    tooltip.setAttribute('aria-hidden', 'true');
    document.body.append(tooltip);
  }
  active = label;
  tooltip.textContent = label.dataset.laasaColour;
  tooltip.hidden = false;
  const rect = label.getBoundingClientRect();
  const tip = tooltip.getBoundingClientRect();
  const left = Math.max(8, Math.min(rect.left + rect.width / 2 - tip.width / 2, window.innerWidth - tip.width - 8));
  const top = rect.top >= tip.height + 12 ? rect.top - tip.height - 7 : rect.bottom + 7;
  tooltip.style.left = `${left}px`;
  tooltip.style.top = `${top}px`;
}
document.addEventListener('pointerover', event => {
  const label = event.target.closest?.(selector);
  if (label && label !== active) show(label);
});
document.addEventListener('pointerout', event => {
  if (active && !active.contains(event.relatedTarget)) hide();
});
document.addEventListener('focusin', event => {
  const label = event.target.closest?.(selector);
  if (label) show(label);
});
document.addEventListener('focusout', hide);
document.addEventListener('scroll', hide, { capture: true, passive: true });
window.addEventListener('resize', hide, { passive: true });
document.addEventListener('keydown', event => { if (event.key === 'Escape') hide(); });

class LaasaSwatchName extends HTMLElement {
  connectedCallback() {
    this.cleanup?.abort();
    this.cleanup = new AbortController();
    const picker = this.closest('swatches-variant-picker-component');
    if (!picker) return;
    const update = input => {
      const label = input?.closest(selector);
      this.textContent = label ? label.dataset.laasaColour : '';
    };
    update(picker.querySelector('input[type="radio"]:checked'));
    picker.addEventListener('change', event => {
      if (event.target.matches('input[type="radio"]')) update(event.target);
    }, { capture: true, signal: this.cleanup.signal });
  }
  disconnectedCallback() { this.cleanup?.abort(); hide(); }
}
if (!customElements.get('laasa-swatch-name')) customElements.define('laasa-swatch-name', LaasaSwatchName);
